export default {
    // === TOWNSFOLK ===
    washerwoman: {
        name: 'Washerwoman',
        description: 'You learn that one of two players has a specific good role.',
        ability: 'On the first night, you learn two players, one of whom has a specific good role.',
    },
    librarian: {
        name: 'Librarian',
        description: 'You learn that one of two players is an Outsider.',
        ability: 'On the first night, you learn two players, one of whom is an Outsider (or that none are in play).',
    },
    investigator: {
        name: 'Investigator',
        description: 'You learn that one of two players is a Minion.',
        ability: 'On the first night, you learn two players, one of whom is a Minion.',
    },
    chef: {
        name: 'Chef',
        description: 'You learn how many pairs of adjacent evil players there are.',
        ability: 'On the first night, you learn how many pairs of adjacent evil players there are.',
    },
    empath: {
        name: 'Empath',
        description: 'You learn how many of your living neighbors are evil.',
        ability: 'Each night, you learn how many of your living neighbors are evil.',
    },
    fortuneteller: {
        name: 'Fortune Teller',
        description: 'You can choose two players and learn if one is the Demon.',
        ability: 'Each night, choose two players: You learn if either is the Demon. There is one good player that always registers as the Demon.',
    },
    undertaker: {
        name: 'Undertaker',
        description: 'You learn the role of the player executed during the day.',
        ability: 'Each night, you learn the role of the player executed during the day.',
    },
    monk: {
        name: 'Monk',
        description: 'You can protect a player from the Demon.',
        ability: 'Each night, choose a player other than yourself: They cannot be killed by the Demon that night.',
    },
    ravenkeeper: {
        name: 'Ravenkeeper',
        description: 'When you die, you learn the role of one player.',
        ability: 'If you die at night, you are woken and choose a player: You learn their role.',
    },
    virgin: {
        name: 'Virgin',
        description: 'The first time someone nominates you, they are executed (if Townsfolk).',
        ability: 'The first time a Townsfolk nominates you, they are immediately executed.',
    },
    slayer: {
        name: 'Slayer',
        description: 'You can publicly choose a player once per game - they die if they are the Demon.',
        ability: 'Once per game, during the day, you can publicly choose a player: If they are the Demon, they die.',
    },
    soldier: {
        name: 'Soldier',
        description: 'You are immune to the Demon ability.',
        ability: 'You are immune to the Demon ability.',
    },
    mayor: {
        name: 'Mayor',
        description: 'If only 3 players live and no one dies, your team wins.',
        ability: 'If only 3 players live and no execution occurs, your team wins.',
    },
    // === OUTSIDER ===
    butler: {
        name: 'Butler',
        description: 'You may only vote when your master votes.',
        ability: 'Each night, choose a player (not yourself): Tomorrow, you may only vote if they vote.',
    },
    drunk: {
        name: 'Drunk',
        description: "You don't know you're the Drunk. You think you're a good role, but your ability doesn't work.",
        ability: "You don't know you're the Drunk. You think you have a Townsfolk ability, but it doesn't work.",
    },
    recluse: {
        name: 'Recluse',
        description: 'You might register as evil or as Minion/Demon, even when dead.',
        ability: 'You might register as evil, as a Minion, or as a Demon, even when dead.',
    },
    saint: {
        name: 'Saint',
        description: 'If you are executed, your team loses.',
        ability: 'If you are executed during the day, the game ends and your team loses.',
    },
    // === MINIONS ===
    poisoner: {
        name: 'Poisoner',
        description: 'You can poison a player each night.',
        ability: 'Each night, choose a player: They are poisoned until the next dusk and their ability does not work.',
    },
    spy: {
        name: 'Spy',
        description: 'You see the Grimoire and might register as good or as Townsfolk/Outsider.',
        ability: 'Each night, you see the Grimoire. You might register as good or as Townsfolk/Outsider.',
    },
    scarletwoman: {
        name: 'Scarlet Woman',
        description: 'If more than 5 players live and the Demon dies, you become the Demon.',
        ability: 'If there are 5 or more players alive and the Demon dies, you become the Demon.',
    },
    baron: {
        name: 'Baron',
        description: 'There are extra Outsiders in play.',
        ability: 'There are 2 additional Outsiders in play.',
    },
    // === DEMON ===
    imp: {
        name: 'Imp',
        description: 'You kill a player each night. If you kill yourself, a Minion dies and becomes the Imp.',
        ability: 'Each night, choose a player: They die. If you choose yourself, a living Minion becomes the Imp.',
    },
};
